export default __webpack_public_path__ + "static/media/Sorcerer's Gloves of Prestige.028fbffc.jpg";